import { imagesConstants } from '../constants';

export const imagesReducer = (state = {}, action) => {
    switch(action.type) {
        case imagesConstants.GET_ALL_IMAGES_REQUEST: 
            return {
                ...state,
                getAllImagesProcess: true
            }

        case imagesConstants.GET_ALL_IMAGES_SUCCESS: 
            return {
                ...state,
                list: {...state.list, ...action.payload},
                getAllImagesProcess: false,
                getAllImagesError: false
            }

        case imagesConstants.GET_ALL_IMAGES_FAILURE:
            return {
                ...state,
                getAllImagesProcess: false,
                getAllImagesError: true
            }

        case imagesConstants.UPDATE_IMAGE_FAILURE:
        {
            let {imageID} = action.payload;

            return {
                ...state,
                updateImageProcessList: {...state.updateImageProcessList, [imageID]: false},
                updateImageErrorList: {...state.updateImageErrorList, [imageID]: true}
            }
        }
            
        case imagesConstants.UPDATE_IMAGE_REQUEST: 
        {
            let {imageID} = action.payload;
            return {
                ...state,
                updateImageProcessList: {...state.updateImageProcessList, [imageID]: true}
            }
        }
        
        case imagesConstants.UPDATE_IMAGE_SUCCESS:
        {
            var {eventID, _id} = action.payload;
            var eventList = state.list && state.list[eventID];
            
            const newEventList = eventList.map((item) => {
                if(item._id === _id) return action.payload;
                return item;
            });

            return {
                ...state,
                list: {...state.list, [eventID]: newEventList},
                updateImageProcessList: {...state.updateImageProcessList, [_id]: false},
                updateImageErrorList: {...state.updateImageErrorList, [_id]: false}
            }
        }

        case imagesConstants.DELETE_IMAGE_FAILURE:
        {
            let {imageID} = action.payload;
            return {
                ...state,
                deleteImageProcessList: {...state.deleteImageProcessList, [imageID]: false},
                deleteImageErrorList: {...state.deleteImageErrorList, [imageID]: true}
            }
        }
            
        case imagesConstants.DELETE_IMAGE_REQUEST:
        {
            let {imageID} = action.payload;
            return {
                ...state,
                deleteImageProcessList: {...state.deleteImageProcessList, [imageID]: true}
            }
        }
        
        case imagesConstants.DELETE_IMAGE_SUCCESS:
        {
            let {eventID, _id} = action.payload;
            let eventList = state.list && state.list[eventID];
            
            const filterdList = eventList.filter((item) => {
                if(item._id === _id) return false;
                return true;
            });

            return {
                ...state,
                list: {...state.list, [eventID]: filterdList},
                deleteImageProcessList: {...state.deleteImageProcessList, [_id]: false},
                deleteImageErrorList: {...state.deleteImageErrorList, [_id]: false}
            }
        }

        case imagesConstants.NEW_IMAGE_FROM_STREAM: 
        {
            let {eventID, _id} = action.payload;
            let images = state.list && state.list[eventID];
            
            // prevent duplicate image
            if(images && images.filter(item => item._id.toString() === _id.toString()).length > 0) return state;

            let updatedImages = images ? [...images, action.payload] : [action.payload];

            return {
                ...state,
                list: {...state.list, [eventID]: updatedImages},
            }
        }

        case imagesConstants.DOWNLOAD_EVENT_IAMGES_REQUEST: 
        {
            let {eventID, chunks} = action.payload;

            return {
                ...state,
                download: {
                    eventID: eventID,
                    process: true,
                    chunks: chunks,
                    downloadedChunks: 0,
                    error: false
                }
            }
        }

        case imagesConstants.DOWNLOADED_EVENT_IAMGES_CHUNK:
        {
            return {
                ...state,
                download: {...state.download, downloadedChunks: ++state.download.downloadedChunks},
            }
        }

        case imagesConstants.DOWNLOAD_EVENT_IMAGES_SUCCESS: 
        {
            return {
                ...state,
                download: {...state.download, process: false, error: false}
            }
        }

        case imagesConstants.DOWNLOAD_EVENT_IMAGES_FAILURE:
        {
            return {
                ...state,
                download: {...state.download, error: true},
            }
        }
        
        default:
            return state;
    }
}

export default imagesReducer;


// WEBPACK FOOTER //
// ./src/reducers/images.js